import { render, staticRenderFns } from "./BillDetails.vue?vue&type=template&id=6fd583f3&scoped=true"
import script from "./BillDetails.vue?vue&type=script&lang=js"
export * from "./BillDetails.vue?vue&type=script&lang=js"
import style0 from "./BillDetails.vue?vue&type=style&index=0&id=6fd583f3&prod&lang=scss&scoped=true"
import style1 from "./BillDetails.vue?vue&type=style&index=1&id=6fd583f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd583f3",
  null
  
)

export default component.exports